import { Typography } from 'antd';

export const TextAndSubText = ({
  text,
  subtext,
  level
}: {
  text: string;
  subtext: string;
  level: 1 | 2 | 3 | 4 | 5;
}) => {
  return (
    <>
      <Typography.Title level={level}>{text}</Typography.Title>
      {typeof subtext === 'string' ? <p style={{ color: '#00000073' }}>{subtext}</p> : subtext}
    </>
  );
};
